import { memo } from 'react';

import { NodeBadge as NodeBadgeType } from '../../../../hooks';

import { NodeBadge } from './NodeBadge';

type NodeBadgesProps = {
  addonLeft?: NodeBadgeType;
  addonRight?: NodeBadgeType;
  addonBottom?: NodeBadgeType;
};

export const NodeBadges = memo(({ addonLeft, addonRight, addonBottom }: NodeBadgesProps) => (
  <>
    {addonLeft && <NodeBadge badge={addonLeft} position="left" />}
    {addonRight && <NodeBadge badge={addonRight} position="right" />}
    {addonBottom && <NodeBadge badge={addonBottom} position="bottom" />}
  </>
));

NodeBadges.displayName = 'NodeBadges';
